(function() {
  function getBeltProperties() {
    var activeModel = document.querySelector('.belt-model-btn.active');
    if (!activeModel || activeModel.dataset.model === '__none__') {
      var defaultModel = document.getElementById('belt-default-model');
      var defaultColor = document.getElementById('belt-default-color');
      console.log('変更なし分岐:', defaultModel, defaultColor);
      if (defaultModel && defaultModel.value) {
        return { model: defaultModel.value, color: defaultColor ? defaultColor.value : '' };
      }
      return null;
    }
    var modelValue = activeModel.dataset.model;
    var activeSwatch = document.querySelector('.belt-color-swatch.active[data-model="' + modelValue + '"]');
    var colorValue = activeSwatch ? activeSwatch.dataset.label : '';
    return { model: modelValue, color: colorValue };
  }

  function injectBelt(form) {
    var belt = getBeltProperties();
    if (!belt) { console.log('No belt selected'); return; }
    var inputs = form.querySelectorAll('input[name^="properties[belt"]');
    for (var i = 0; i < inputs.length; i++) inputs[i].remove();
    ['belt-model', 'belt-color'].forEach(function(key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.value = key === 'belt-model' ? belt.model : (belt.color || '');
      form.appendChild(input);
    });
    console.log('Belt injected:', belt);
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cowlendar-add-to-cart, button[name="add"], [data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    injectBelt(form);
  }, true);

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    injectBelt(form);
  }, true);

  console.log('Belt listener ready');
})();
